<template>
    <keep-alive>
        <component :is="loadPages"></component>
    </keep-alive>

    <Footer id="footer_section" class="fixed-bottom" />
</template>


<script>
    import { computed, defineAsyncComponent, onBeforeMount } from "vue";

    import { useStore } from "@/store";
    import { useRoute } from "vue-router";

    import Footer from '@/components/footer/FooterSimple.vue';

    import { G, ajax } from "@/_common";

    export default {
        name: '404errorL',
        components: {
            Footer,
        },
        props: {
            data: {
                type: Object,
                default: () => {}
            },
        },
        setup(props) {
            const store = useStore();
            const route = useRoute();

            const def_lang = route.params && route.params.lang ? route.params.lang : "az";
            store.setLang(def_lang);

            const gpage = G.current;

            gpage.page = props.data
                ? props.data.page || G.defaultPage
                : G.defaultPage;

            onBeforeMount(async () => {
                await ajax({
                    url: store.getTranslations(),
                    success: (e) => {
                        store.setTranslations(e.data);
                    },
                });
            });

            const loadPages = computed(() => {
                return defineAsyncComponent({
                    loader: () => import(`@/${gpage.page}`),
                    errorComponent: defineAsyncComponent(() =>
                        import("@/system_modules/NotFound")
                    ),
                });
            });

            return { loadPages };
        },
    };
</script>


<style lang="scss">
    #nprogress .bar {
        height: 4px;
    }
    #nprogress .spinner {
        right: auto;
        top: 50%;
        left: 50%;
    }
    .main-content {
        width: calc(100% - 280px);
    }
    @media (max-width: 576px) {
        .main-content {
            width: 100%;
        }
    }
</style>
